import { FEATURE_FLAG } from '~/constants/featureFlags';

import { type RouteExportParams } from '~/types/router.type';

export const routeParams: RouteExportParams = {
  permissions: ['company.'],
  disablingFeatureFlag: FEATURE_FLAG.DISABLE_INVOICES,
};
